import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';

import { Discount, Stylist } from '../../../../models';
import { UserService } from '../../../../services/user.service';
import { StylistService } from '../../../../services/stylist.service';
import { List } from 'immutable';
import { StylistPickerComponent } from '../../../../components/stylist-picker/stylist-picker.component';
import { StylistDiscountFormComponent } from './stylist-discount-form/stylist-discount-form.component';
@Component({
  selector: 'app-stylist-discounts',
  templateUrl: './stylist-discounts.page.html',
  styleUrls: ['./stylist-discounts.page.scss'],
})
export class StylistDiscountsPage implements OnInit {

  @ViewChild(StylistPickerComponent) stylistPickerComponent: StylistPickerComponent;

  public isLoading: boolean;

  public readOnlyStylistPicker: boolean;

  public discounts: List<Discount>;

  public stylist: Stylist;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public errorOccuredWhileLoadingDiscounts: boolean;

  constructor (private userService: UserService,
               private stylistService: StylistService,
               private navController: NavController,
               private modalController: ModalController,
               private ref: ChangeDetectorRef
  ) {
    this.isLoading = true;
    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.onStylistSelect(user.clone());
      this.readOnlyStylistPicker = !(user.isAdministrator() || user.getViewAllCalendars() === 1);
    }

    this.discounts=  List([]);
  }

  public ngOnInit () {
  }

  public onStylistPickerInit (initResponse: {success: boolean, stylist: Stylist}) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
      this.ref.detectChanges();
    }
  }

  public onStylistSelect (stylist: Stylist) {
    this.stylist = stylist;
    this.loadDiscounts(this.stylist);
  }

  public loadDiscounts (stylist: Stylist) {
    this.isLoading = true;
    this.errorOccuredWhileLoadingDiscounts = false;
    this.stylistService.getDiscounts(stylist)
      .subscribe({next: (discounts) => {
          this.discounts = discounts;
          this.isLoading = false;
          this.ref.detectChanges();
        },
        error: (err) => {
          this.isLoading = false;
          this.errorOccuredWhileLoadingDiscounts = true;
          this.ref.detectChanges();
        }});
  }

  public onTapToReload () {
    this.isLoading = true;

    if (this.errorOccurredWhileLoadingStylistPicker) {
      this.errorOccurredWhileLoadingStylistPicker = false;
      this.stylistPickerComponent.ngOnInit();
    } else if (this.errorOccuredWhileLoadingDiscounts) {
      this.errorOccuredWhileLoadingDiscounts = false;
      this.loadDiscounts(this.stylist);
    }
  }


  public async onDiscountEditHandler (discount: Discount, index: number) {
    discount = discount.setStylistID(this.stylist.id);
    const modal = await this.modalController.create({
      component: StylistDiscountFormComponent,
      componentProps: {
        discount: discount
      }
    })
    modal.onWillDismiss().then((data:any) => {
      if (data.data) {
        if (data.data.action === 'save') {
          this.discounts = this.discounts.set(index, data.data.discount);
        } else {
          this.discounts = this.discounts.remove(index);
        }
      }
    });
    modal.present();
  }

  public async createDiscount () {
    const discount: Discount = new Discount({
      id: undefined,
      name: '',
      type: 0,
      amount: 0,
      discountCommission: 0,
      stylistID: this.stylist.id
    });
    const modal = await this.modalController.create({
      component: StylistDiscountFormComponent,
      componentProps: {
        discount: discount
      }
    })
    modal.onWillDismiss().then((data: any) => {
      if (data.data) {
        this.discounts = this.discounts.push(data.data.discount);
      }
    });
    modal.present();
  }


}

